define('form/selector',['jquery', 'form/completer', 'utils/common'], function ($, Completer) {
	
	/**
	 * Selector
	 * Handles selections with autosuggestions together
	 * 
	 * options:
	 * 	Source: Source waar de selector gegevens vandaan haalt
	 * 	bool: emptyOnSelect: Haal het invul veld leeg als er wat geselecteerd is
	 * 	bool: multiSelect: Multiple selections mogelijk?
	 * 	bool: onlyExists: Alleen maar bestaande items uit de lijst of ook nieuwe
	 * 
	 * usage:
	 * 	inputElement.formSelector(options)
	 */
	var Selector = function (element, options) {
		var defaults = $.extend({
			source : null,
			
			emptyOnSelect : true,
			multiSelect : true,
			onlyExists : false,
			focus : false,
			
			score : null
		}, options);
		this.options = defaults;
		var $this = this;
		
		this.element = $(element);
		this.container = this.element.parent().find('.sels');
		
		this.container.on('click', 'a', function (e) {
			e.preventDefault();
			
			$this.options.source.onRemove($(this).parent('span').data('id'));
			
			$(this).parent().remove();
			
			return false;
		});
		
		this.getInput = function () {
			return this.element;
		};
		
		this.existsSelectie = function (label) {
			var exists = false;
			label = label.toLowerCase();
			$.each($this.container.find('span'), function () {
				if($(this).text().toLowerCase() == label) {
					exists = true;
				}
			});
			return exists;
		};
		
		var src = this.options.source;
		
		// Default action icm autocomplete e.d.
		var defaultChoiceAction = function (item) {
			if($this.options.emptyOnSelect) 
				$this.element.val('');
			
			if($this.options.multiSelect) {
				$this.add(src.getLabel(item), item);
			}
			
			$this.element.autocomplete("close");
		};
		
		// init autocompleter
		this.c = $(this.element).completer({
			source : defaults.source,
			
			score : defaults.score,
			
			onEnter : function (label) {
				if(label == "" || $this.existsSelectie(label)) return;
				
				var item = src.getItem(function (item) {
					return this.getLabel(item).toLowerCase() == label.toLowerCase();
				});
				
				
				if(item == null) {
					// item = new
					item = {isNew : true};
					item[src.options.value] = label;
				} 
					
				// callback to source when succesvol added
				src.onAdd(item);
				
				// only add if option is known
				if(!$this.options.onlyExists || item.isNew == undefined ) {   
					defaultChoiceAction(item);
				} 
			},
			
			// gekozen via lijst met de muis of pijltjes
			onChoice : function (item) {
				if($this.existsSelectie(src.getLabel(item))) return;
				defaultChoiceAction(item);
				
				src.onAdd(item);
			},
			directShow : defaults.focus
		}).data('completer'); 
	};
	
	Selector.prototype.localAdd = function (value, data) {
		this.add(value, data);
		this.options.source.onAdd(data);
	};
	
	Selector.prototype.reset = function () {
		this.c.reset();
		this.container.empty();
	};
	
	/** 
	 * Add a item to the list
	 * @param value
	 * @param data
	 */
	Selector.prototype.add = function (value, data) {
		if(value == "") return;
		var sel = $('<span>').html(value.htmlspecialchars()).attr('data-id', data.id);
		sel.append($('<a href="#"></a>'));
		this.container.append(sel);
	};
	
	/**
	 * jQuery variant op Selector
	 * .data(selector) == Selector
	 */
	$.fn.formSelector = function (global_settings) {
		
		return this.each(function () {
			var el = $(this);
			var obj = new Selector(el, global_settings);
			
			el.data('selector', obj);
			
			return el;
		});
	};
	
	return Selector;
});

